import { render, staticRenderFns } from "./AlgorithmEditor.vue?vue&type=template&id=60db7892&"
import script from "./AlgorithmEditor.vue?vue&type=script&lang=js&"
export * from "./AlgorithmEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports